import styled from "styled-components";

export const FiltersContainer = styled.div`
  height: 40px;
  width: 100%;
  display: flex;
  align-items: center;
`;

export const FiltersLeftContent = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  flex: 1;
`;

export const FiltersRightContent = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 16px;
`;

export const SearchContainer = styled.div`
  min-width: 200px;
`; 